// extracted by mini-css-extract-plugin
module.exports = {"portfolio-box":"PortfolioBox_portfolio-box__2a9zP","image-wrapper":"PortfolioBox_image-wrapper___U-AT","image-title":"PortfolioBox_image-title__2ZkDD"};